export enum DashboardExportsSummaryTypeEnum {
    CSV = 'CSV',
    Dynamics_365 = 'Dynamics',
    HubSpot = 'HubSpot',
    Marketo = 'Marketo',
    Outreach = 'Outreach',
    Salesforce = 'Salesforce',
    Salesloft = 'Salesloft',
    Zoho = 'Zoho',
    Reveals = 'Reveal',
}
